<template id="theater">
    <div class="Theater modal-backdrop" :class="isTheaterClose" @click.prevent="close">
        <div class="Theater__room" @click.stop>
            <template v-if="isPhotoSelected">
                <div class="Theater__stage">
                    <figure class="Theater__figure">
                        <img :id="'theater-img-' + selectedPhoto.id" :src="selectedPhoto.images['1100']" class="Theater__image" v-bind:alt="'Photo of '+selectedPhoto['park']['name']" />
                    </figure>
                    <div class="Theater__commands" v-if="photoIndex >= 0">
                        <button :disabled="photoIndex === 0" class="Theater__command Theater__command--left" href="#previous" @click.prevent="previousPhoto">
                            <svg-icon class="svg-32 ic-white-stroke" icon="ic-chevron-left"></svg-icon>
                        </button>
                        <button :disabled="isLastPhoto(photoIndex)" class="Theater__command Theater__command--right" href="#next" @click.prevent="nextPhoto">
                            <svg-icon class="svg-32 ic-white-stroke" icon="ic-chevron-right"></svg-icon>
                        </button>
                    </div>
                </div>
                <theater-content :photo="selectedPhoto" :user="user" @report-state="handleReportState"></theater-content>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        name: "theater",
        props: ['authUser'],
        data() {
            return {
                user: this.$props.authUser || this.$parent.user,
                reportModalOpen: false,
            }
        },

        beforeDestroy() {
            window.removeEventListener("keyup", this.checkPressedKey, false);
        },

        created() {
            window.addEventListener("keyup", this.checkPressedKey);
        },

        computed: {
            photoIndex: function() {
                return this.$store.getters.photoIndex;
            },

            selectedPhoto: function() {
                var p = this.$store.getters.selectedPhoto;
                this.addInterEvent('park_photo', p['park']['id'])
                return p;
            },

            isPhotoSelected: function() {
                return this.$store.getters.isPhotoSelected;
            },

            isTheaterClose: function() {
                return {
                    "Theater--closed": !this.isPhotoSelected,
                }
            },
        },

        methods: {
            handleReportState(value) {
                this.reportModalOpen = value
            },
            checkPressedKey(e) {
                e = e || window.event;

                // When report modal is visible disable arrow key nav
                if (this.reportModalOpen && (e.keyCode === 37 || e.keyCode === 39)) {
                    return;
                }
                
                switch (e.keyCode) {
                    case 27: // escape key
                        this.close();
                        break;
                    case 37: // left arrow key code
                        this.previousPhoto();
                        break;
                    case 39: // right arrow key code
                        this.nextPhoto();
                        break;
                }
            },

            previousPhoto() {
                this.$store.commit("previousPhotoOfIndex", this.photoIndex - 1);
            },

            nextPhoto() {
                if (this.$store.getters.photos!== undefined && this.$store.getters.photos.length == this.photoIndex + 1)
                {
                    this.$store.commit("nextPhotoOfIndex", 0);
                }
                else {
                    this.$store.commit("nextPhotoOfIndex", this.photoIndex + 1);
                }
            },

            close() {
                this.$parent.startphoto = {};
                this.$store.commit("changeSelectedPhoto", {});
            },

            isLastPhoto(index) {
                return this.$parent.photosToList != undefined && index == this.$parent.photosToList[0].length-1;
            }
        }
    }
</script>
